import { ResponseDataRequestsItem } from '../requests/types'

export enum AuditsActionTypes {
  GET_AUDITS = '@audits/GET_AUDITS',
  GET_AUDITS_FAILURE = '@audits/GET_AUDITS_FAILURE',
  GET_AUDITS_SUCCESS = '@audits/GET_AUDITS_SUCCESS'
}

export interface AuditsState {
  readonly error: string
  readonly filterRequestNumber: string
  readonly filterRequestTravelerName: string
  readonly filterStatus: string[]
  readonly list: ResponseDataRequestsItem[]
  readonly loading: boolean
  readonly total_results: number
}
